import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getDivisi = 'divisi';
const postDivisiUrl = 'divisi';
const putDivisi = 'divisi/';
const deleteDivisi = 'divisi/';

class DivisiService {

    postDivisi(formData) {
        return axios
            .post(
                API_URL + postDivisiUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putDivisi(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putDivisi + formData.idDivisi, formData,
                { headers: authHeader() }
            );
    }

    deleteDivisi(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteDivisi + formData.idDivisi,
                { headers: authHeader() }
            );
    }
    // ?pageNo=0&pageSize=10&sortBy=id&filter=r
    getDivisi(currentPage,pageSize,filter){
        
        return axios.get(
            API_URL + getDivisi + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            { headers: authHeader() 
        });
    }

}

export default new DivisiService();